var amdi18n={"__root":{"insert_pin_text":"Please enter PIN","repeat_pin_text":"Please repeat PIN","min_secret_length":"Please enter PIN with at least %% characters","error_match_text":"The PINs do not match","apply_button":"Apply","additional_fido":"additional FIDO-protection","activate_fido":"Please insert your <a href=\"https://www.skidentity.de/en/faq/faq1/#fido\" target=\"_blank\">FIDO</a>-Key and click \"Next\".","activate_fido_mobile":"Please click \"Next\" and then hold your <a href=\"https://www.skidentity.de/en/faq/faq1/#fido\" target=\"_blank\">FIDO</a>-Key to the mobile."},"__de":{"insert_pin_text":"Bitte PIN eingeben","repeat_pin_text":"Bitte PIN wiederholen","min_secret_length":"Bitte PIN mit mindestens %% Zeichen eingeben","error_match_text":"Die PINs sind unterschiedlich","apply_button":"Übernehmen","additional_fido":"zusätzlicher FIDO-Schutz","activate_fido":"Bitte <a href=\"https://www.skidentity.de/faq/faq1/#fido\" target=\"_blank\">FIDO</a>-Token stecken und auf \"Weiter\" klicken.","activate_fido_mobile":"Bitte klicken Sie auf \"Weiter\" und halten Sie dann Ihren <a href=\"https://www.skidentity.de/faq/faq1/#fido\" target=\"_blank\">FIDO</a>-Token an das Mobiltelefon."}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/view/identity/nls/IdentityEncryptView_strings.js
// module id = 160
// module chunks = 1